<template>
  <a-modal
    :visible="visible"
    title="上传照片"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :width="700"
    @cancel="cancelHandel"
  >
    <a-row :gutter="60">
      <a-col :xs="24" :md="12" :style="{ height: '350px' }">
        <vue-cropper
          ref="cropper"
          outputType=“png”
          :img="img"
          :info="true"
          :infoTrue="true"
          :autoCrop="true"
          :autoCropWidth="200"
          :autoCropHeight="280"
          :centerBox="true"
          :full="true"
          :fixed="true"
          :fixedNumber="[5,7]"
          :fixedBox="true"
          :canMoveBox="false"
          :enlarge="1"
          mode="cover"
          @realTime="realTime"
        >
        </vue-cropper>
      </a-col>
      <a-col :xs="24" :md="12" :style="{ height: '350px' }" v-if="!_isMobile()">
        <p>预览</p>
        <div class="avatar-upload-preview">
          <img :src="previews.url" :style="previews.img" />
        </div>
      </a-col>
    </a-row>

    <template slot="footer">
      <div style="float:left;display:inline-block;margin-bottom: 10px;">
          <input
            type="file"
            id="uploads"
            style="position: absolute; clip: rect(0 0 0 0)"
            accept="image/png, image/jpeg, image/gif, image/jpg"
            @change="selectImgOk($event, 1)"
          />
          <a-button type="primary" @click="selectImg">选择照片</a-button>
          <a-divider type="vertical"></a-divider>
          <a-button-group >
            <a-button icon="zoom-in" style="background-color:#F4F4F5 ;"  @click="changeScale(1)"></a-button>
            <a-button icon="zoom-out" style="background-color:#F4F4F5 ;"  @click="changeScale(-1)"></a-button>
          </a-button-group>
          <a-divider type="vertical"></a-divider>
          <a-button-group >
             <a-button icon="undo" style="background-color:#F4F4F5 ;"  @click="rotateLeft"></a-button>
             <a-button icon="redo" style="background-color:#F4F4F5 ;"  @click="rotateRight"></a-button>
          </a-button-group>

         
      </div>
      <a-divider></a-divider>
      <a-button key="back" @click="cancelHandel">取消</a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="confirmLoading"
        @click="upload"
        >保存</a-button
      >
    </template>
  </a-modal>
</template>
<script>
import { VueCropper } from "vue-cropper";
import { upload2Qiniu, dataURLtoBlob } from "@/utils/qiniu.js";
import {getAction , postAction, deleteAction} from "@/api/manage"
import { mixinDevice } from '@/utils/mixin.js'
export default {
  mixins:[mixinDevice],
  components: {
    VueCropper,
  },
  props:{
    saveToDB:{ //保存文件记录
      type: Boolean,
      default: true
    },
    img:{
      type: String,
      default: ""
    }
  },
  data() {
    return {
      visible: false,
      id: null,
      confirmLoading: false,
      // img: "",
      fileName: "",
      file: null,
      previews: {},
      sysFileId: ""
    };
  },
  methods: {
    upload2Qiniu: upload2Qiniu,
    dataURLtoBlob: dataURLtoBlob,
    edit(id) {
      this.visible = true;
      this.id = id;
      /* 获取原始头像 */
    },
    close() {
      this.id = null;
      this.visible = false;
    },
    cancelHandel() {
      this.close();
    },
    //点击保存
    upload() {
      let that = this
      let observer = {
        next(res) {},
        error(err) {
          this.$message.error("上传失败");
        },
        complete(res) {
          that.uploadOk(res.key);
        },
      };
      this.$refs.cropper.getCropBlob((data) => {
        upload2Qiniu(data, "照片上传.png", observer);
      });
    },
    uploadOk(key){
      if(this.saveToDB){
        postAction("/system/sysFile/add", {
          fileName: this.fileName,
          filePath: key,
          fileLocation: 2,
          fileTag: "照片上传",
          fileSize: this.file.size
        }).then(res=>{
          if(res.success){
            this.sysFileId = res.result.id
            this.$emit("ok", key, this.sysFileId)
            this.visible = false
          }
        })
      }else{
        this.$emit("ok", key)
      }
      
    },
    //实时预览
    realTime(data) {
      this.previews = data;
    },
    selectImg(){
      window.document.getElementById('uploads').click()
    },
    //选择本地图片
    selectImgOk(e, num) {
      var _this = this;
      _this.file = e.target.files[0];
      if(_this.file.size < 102400){
        this.$message.error("请上传大于100KB的图片");
        return false;
      }
      _this.fileName = _this.file.name;
      if (!/.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        this.$message.error("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
        return false;
      }
      var reader = new FileReader();
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        if (num === 1) {
          _this.img = data;
        } else if (num === 2) {
          _this.example2.img = data;
        }
      };
      reader.readAsArrayBuffer(_this.file);
    },
    //放大/缩小
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    //坐旋转
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    //右旋转
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
  },
};
</script>

<style lang="less" scoped>
.avatar-upload-preview {
  position: absolute;
  width: 200px;
  height: 280px;
  box-shadow: 0 0 4px #ccc;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
}

</style>